import React from 'react';
import { Link } from 'react-router-dom';
import { FaPhone, FaEnvelope, FaMapMarkerAlt, FaWhatsapp } from 'react-icons/fa';
import { useApp } from '../../context/AppContext';
import ManageCookies from '../ManageCookies';
import './footer.css';

const Footer = () => {
    const { t } = useApp();
    const currentYear = new Date().getFullYear();

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };

    return (
        <footer className="footer">
            <div className="footer-container">
                {/* Footer Top */}
                <div className="footer-top">
                    <div className="footer-column footer-about">
                        <div className="footer-logo">
                            <img src={require('../../logo.png')} alt="MachineryA3 Logo" />
                        </div>
                        <p className="footer-description">
                            {t.footer.description}
                        </p>
                        <div className="footer-social">
                            
                            <a href="https://wa.me/40756048228" target="_blank" rel="noopener noreferrer" className="social-link" aria-label="WhatsApp">
                                <FaWhatsapp />
                            </a>
                        </div>
                    </div>

                    <div className="footer-column">
                        <h3 className="footer-title">{t.footer.quickLinks.title}</h3>
                        <ul className="footer-links">
                            <li><Link to="/" onClick={scrollToTop}>{t.footer.quickLinks.home}</Link></li>
                            <li><Link to="/machines" onClick={scrollToTop}>{t.footer.quickLinks.inventory}</Link></li>
                            <li><Link to="/about" onClick={scrollToTop}>{t.footer.quickLinks.about}</Link></li>
                            <li><Link to="/services" onClick={scrollToTop}>{t.footer.quickLinks.services}</Link></li>
                            <li><Link to="/contact" onClick={scrollToTop}>{t.footer.quickLinks.contact}</Link></li>
                        </ul>
                    </div>

                    <div className="footer-column">
                        <h3 className="footer-title">{t.footer.categories.title}</h3>
                        <ul className="footer-links">
                            <li><Link to="/machines?category=excavatoare" onClick={scrollToTop}>Excavatoare</Link></li>
                            <li><Link to="/machines?category=incarcatoare" onClick={scrollToTop}>Încărcătoare</Link></li>
                            <li><Link to="/machines?category=buldozere" onClick={scrollToTop}>Buldozere</Link></li>
                            <li><Link to="/machines?category=cilindri-compactori" onClick={scrollToTop}>Cilindri compactori</Link></li>
                            <li><Link to="/machines?category=automacarale" onClick={scrollToTop}>Automacarale</Link></li>
                        </ul>
                    </div>

                    <div className="footer-column footer-contact-column">
                        <h3 className="footer-title">{t.footer.contact.title}</h3>
                        <ul className="footer-contact">
                            <li>
                                <FaPhone className="contact-icon" />
                                <a href="tel:+40756048228">+40 756 048 228</a>
                            </li>
                            <li>
                                <FaEnvelope className="contact-icon" />
                                <a href="mailto:office@terasamente.com">office@terasamente.com</a>
                            </li>
                            <li>
                                <FaMapMarkerAlt className="contact-icon" />
                                <span>{t.footer.contact.location}</span>
                            </li>
                        </ul>
                    </div>
                    
                    <div className="footer-column footer-hours-column">
                        <h3 className="footer-title">{t.footer.contact.hours}</h3>
                        <div className="footer-hours-card">
                            <div className="footer-hours-content">
                                <p className="footer-hours-weekday">
                                    <strong>Luni - Vineri:</strong> 8:00 - 18:00
                                </p>
                                <p className="footer-hours-saturday">
                                    <strong>Sâmbătă:</strong> 9:00 - 14:00
                                </p>
                                <p className="footer-hours-sunday">
                                    <strong>Duminică:</strong> Închis
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Footer Bottom */}
                <div className="footer-bottom">
                    <div className="footer-bottom-content">
                        <p className="footer-copyright">
                            © {currentYear} MachineryA3. {t.footer.copyright}
                        </p>
                        <div className="footer-legal">
                            <a href="#privacy">{t.footer.privacy}</a>
                            <span className="separator">|</span>
                            <a href="#terms">{t.footer.terms}</a>
                            <span className="separator">|</span>
                            <Link to="/cookie-policy" onClick={scrollToTop}>{t.footer.cookies || 'Cookie Policy'}</Link>
                            <span className="separator">|</span>
                            <ManageCookies />
                        </div>
                    </div>
                </div>
            </div>

            {/* Decorative Wave */}
            <div className="footer-wave">
                <svg viewBox="0 0 1200 120" preserveAspectRatio="none">
                    <path d="M0,0V46.29c47.79,22.2,103.59,32.17,158,28,70.36-5.37,136.33-33.31,206.8-37.5C438.64,32.43,512.34,53.67,583,72.05c69.27,18,138.3,24.88,209.4,13.08,36.15-6,69.85-17.84,104.45-29.34C989.49,25,1113-14.29,1200,52.47V0Z" opacity=".25"></path>
                    <path d="M0,0V15.81C13,36.92,27.64,56.86,47.69,72.05,99.41,111.27,165,111,224.58,91.58c31.15-10.15,60.09-26.07,89.67-39.8,40.92-19,84.73-46,130.83-49.67,36.26-2.85,70.9,9.42,98.6,31.56,31.77,25.39,62.32,62,103.63,73,40.44,10.79,81.35-6.69,119.13-24.28s75.16-39,116.92-43.05c59.73-5.85,113.28,22.88,168.9,38.84,30.2,8.66,59,6.17,87.09-7.5,22.43-10.89,48-26.93,60.65-49.24V0Z" opacity=".5"></path>
                    <path d="M0,0V5.63C149.93,59,314.09,71.32,475.83,42.57c43-7.64,84.23-20.12,127.61-26.46,59-8.63,112.48,12.24,165.56,35.4C827.93,77.22,886,95.24,951.2,90c86.53-7,172.46-45.71,248.8-84.81V0Z"></path>
                </svg>
            </div>
        </footer>
    );
};

export default Footer;
